<div class="comparison-close">
  <a (click)="close()" class="close-button">
    <img src="/assets/svgs/icons/close-black.svg" class="svg icon" />
  </a>
</div>
<div class="grid grid-wrapper">
  <div class="cell cell-large-col-span-12 bg-light comparison-header padding-medium">
    <h2 class="margin-bottom-small"> Compare our car insurance covers</h2>
    <div class="block bg-lightSurface">
      <label class="text-openBlue"> Third Party Property</label>
      <p class="text-small"> Covers you for damage the use of your car causes to other people&apos;s vehicles and property.</p>
      <p class="text-small"> Choose to extend Third Party Property by adding fire and theft cover, for up to $10,000.</p>
      <label class="text-openBlue"> Everyday Comprehensive</label>
      <p class="text-small"> Covers you for accidental damage to your car, plus damage the use of your car causes to other people&apos;s vehicles and property.</p>
      <label class="text-openBlue"> Huddle Black Comprehensive</label>
      <p class="text-small"> Enjoy all the features of Everyday Comprehensive with our highest limits and exclusive benefits.</p>
    </div>
  </div>
</div>

<div class="grid grid-wrapper">
  <div class="cell cell-large-col-span-12">
    <h4 class="margin-top-medium margin-bottom-small"> Cover summary</h4>
    <div class="margin-vertical-small">
      <div class="table-heading-row">
        <div class="grid padding-vertical-xsmall">
          <div class="cell cell-large-col-span-3 cell-medium-col-span-8 cell-small-col-span-6"></div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <label class="text-small text-black"> Third Party Property</label>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <label class="text-small large-3 text-black">Everyday Comprehensive</label>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <label class="text-small text-black"> Huddle Black Comprehensive</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="margin-bottom-large">
  <div>
    <ul class="product-cover list-style-none padding-none">
      <li class="padding-bottom-small">
        <div class="grid margin-top-xsmall">
          <div class="cell cell-large-col-span-3 cell-medium-col-span-8 cell-small-col-span-6">
            <label class="text-small text-black margin-bottom-xsmall">Your car is damaged as a result of a collision</label>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-orange.svg" />
            <div class="text-xsmall">Up to $3,000 if caused by another uninsured driver and policy conditions are met</div>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-black.svg" />
          </div>
        </div>
      </li>
      <li class="padding-bottom-small">
        <div class="grid margin-top-xsmall">
          <div class="cell cell-large-col-span-3 cell-medium-col-span-8 cell-small-col-span-6">
            <label class="text-small text-black margin-bottom-xsmall"> Your car is damaged as a result of theft, attempted theft or fire</label>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-orange.svg" />
            <div class="text-xsmall"> Up to $10,000, if fire &amp; theft option is selected</div>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-black.svg" />
          </div>
        </div>
      </li>
      <li class="padding-bottom-small">
        <div class="grid margin-top-xsmall">
          <div class="cell cell-large-col-span-3 cell-medium-col-span-8 cell-small-col-span-6">
            <label class="text-small text-black margin-bottom-xsmall"> Legal Liability Cover#[br]For when the use of your car cases damage to another person’s property</label>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-orange.svg" />
            <div class="text-xsmall"> Up to $20 million</div>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
            <div class="text-xsmall"> Up to $20 million</div>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-black.svg" />
            <div class="text-xsmall"> Up to $30 million</div>
          </div>
        </div>
      </li>
      <li class="padding-bottom-small">
        <div class="grid margin-top-xsmall">
          <div class="cell cell-large-col-span-3 cell-medium-col-span-8 cell-small-col-span-6">
            <label class="text-small text-black margin-bottom-xsmall"> Your car is damaged as a result of a natural event like storm or flood</label>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/not-covered.svg" />
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-black.svg" />
          </div>
        </div>
      </li>
      <li class="padding-bottom-small">
        <div class="grid margin-top-xsmall">
          <div class="cell cell-large-col-span-3 cell-medium-col-span-8 cell-small-col-span-6">
            <label class="text-small text-black margin-bottom-xsmall"> Your car suffers loss or damage as a result of a malicious act</label>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/not-covered.svg" />
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-black.svg" />
          </div>
        </div>
      </li>
      <li class="padding-bottom-small">
        <div class="grid margin-top-xsmall">
          <div class="cell cell-large-col-span-3 cell-medium-col-span-8 cell-small-col-span-6">
            <label class="text-small text-black margin-bottom-xsmall"> Pay As You Drive Cover#[br]Save by choosing a KM range from 1,000 to 15,000 that your car will drive in a year</label>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/not-covered.svg" />
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <div class="text-xsmall"> Optional</div>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <div class="text-xsmall"> Optional</div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>


<div class="grid grid-wrapper">
  <div class="cell cell-large-col-span-12">
    <h4 class="margin-top-medium margin-bottom-small"> Additional benefits</h4>
    <div class="margin-vertical-small">
      <div class="table-heading-row">
        <div class="grid padding-vertical-xsmall">
          <div class="cell cell-large-col-span-3 cell-medium-col-span-8 cell-small-col-span-6"></div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
              <label class="text-small text-black"> Third Party Property</label>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <label class="text-small large-3 text-black"> Everyday Comprehensive</label>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <label class="text-small text-black"> Huddle Black Comprehensive</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="margin-bottom-large">
  <div class="">
    <ul class="product-cover list-style-none padding-none">
      <li class="padding-bottom-small">
        <div class="grid margin-top-xsmall">
          <div class="cell cell-large-col-span-3 cell-medium-col-span-8 cell-small-col-span-6">
            <label class="text-small text-black margin-bottom-xsmall"> New for old car replacement</label>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/not-covered.svg" />
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
            <div class="text-xsmall"> Up to 2 years</div>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-black.svg" />
            <div class="text-xsmall"> Up to  3 years</div>
            <div class="text-xsmall"> (as long as under 70,000kms)</div>
          </div>
        </div>
      </li>
      <li class="padding-bottom-small">
        <div class="grid margin-top-xsmall">
          <div class="cell cell-large-col-span-3 cell-medium-col-span-8 cell-small-col-span-6">
            <label class="text-small text-black margin-bottom-xsmall"> Personal property</label>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-orange.svg" />
            <div class="text-xsmall"> Up to $500, if fire and theft option selected</div>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
            <div class="text-xsmall"> Up to $500</div>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-black.svg" />
            <div class="text-xsmall"> Up to $1000</div>
          </div>
        </div>
      </li>
      <li class="padding-bottom-small">
        <div class="grid margin-top-xsmall">
          <div class="cell cell-large-col-span-3 cell-medium-col-span-8 cell-small-col-span-6">
            <label class="text-small text-black margin-bottom-xsmall"> Emergency travel and accommodation</label>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-orange.svg" />
            <div class="text-xsmall"> Up to $500, if fire &amp; theft option is selected</div>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
            <div class="text-xsmall"> Up to $500</div>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-black.svg" />
            <div class="text-xsmall"> Up to $2000</div>
          </div>
        </div>
      </li>
      <li class="padding-bottom-small">
        <div class="grid margin-top-xsmall">
          <div class="cell cell-large-col-span-3 cell-medium-col-span-8 cell-small-col-span-6">
            <label class="text-small text-black margin-bottom-xsmall"> Towing costs</label>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-orange.svg" />
            <div class="text-xsmall"> Reasonable costs, if fire and theft option selected</div>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
            <div class="text-xsmall"> Reasonable costs</div>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-black.svg" />
            <div class="text-xsmall"> Reasonable costs</div>
          </div>
        </div>
      </li>
      <li class="padding-bottom-small">
        <div class="grid margin-top-xsmall">
          <div class="cell cell-large-col-span-3 cell-medium-col-span-8 cell-small-col-span-6">
            <label class="text-small text-black margin-bottom-xsmall"> Essential repairs</label>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-orange.svg" />
            <div class="text-xsmall"> Up to $500, if fire and theft option selected</div>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
            <div class="text-xsmall"> Up to $500</div>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-black.svg" />
            <div class="text-xsmall"> Up to $500</div>
          </div>
        </div>
      </li>
      <li class="padding-bottom-small">
        <div class="grid margin-top-xsmall">
          <div class="cell cell-large-col-span-3 cell-medium-col-span-8 cell-small-col-span-6">
            <label class="text-small text-black margin-bottom-xsmall"> Hire car after theft</label>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-orange.svg" />
            <div class="text-xsmall"> Up to $70 per day for up to 14 days, if fire and theft option selected</div>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
            <div class="text-xsmall"> Up to $70 per day for up to 14 days</div>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-black.svg" />
            <div class="text-xsmall"> Up to $80 per day for up to 14 days</div>
          </div>
        </div>
      </li>
      <li class="padding-bottom-small">
        <div class="grid margin-top-xsmall">
          <div class="cell cell-large-col-span-3 cell-medium-col-span-8 cell-small-col-span-6">
            <label class="text-small text-black margin-bottom-xsmall"> Trailer and caravan cover</label>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/not-covered.svg" />
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
            <div class="text-xsmall"> Up to $1000</div>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-black.svg" />
            <div class="text-xsmall"> Up to $1000</div>
          </div>
        </div>
      </li>
      <li class="padding-bottom-small">
        <div class="grid margin-top-xsmall">
          <div class="cell cell-large-col-span-3 cell-medium-col-span-8 cell-small-col-span-6">
            <label class="text-small text-black margin-bottom-xsmall"> Transit cover</label>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/not-covered.svg" />
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-black.svg" />
          </div>
        </div>
      </li>
      <li class="padding-bottom-small">
        <div class="grid margin-top-xsmall">
          <div class="cell cell-large-col-span-3 cell-medium-col-span-8 cell-small-col-span-6">
            <label class="text-small text-black margin-bottom-xsmall"> Child safety seats and prams</label>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/not-covered.svg" />
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-black.svg" />
          </div>
        </div>
      </li>
      <li class="padding-bottom-small">
        <div class="grid margin-top-xsmall">
          <div class="cell cell-large-col-span-3 cell-medium-col-span-8 cell-small-col-span-6">
            <label class="text-small text-black margin-bottom-xsmall"> Locks and keys</label>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-orange.svg" />
            <div class="text-xsmall"> Up to $1000, if fire and theft option selected</div>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-green.svg" />
            <div class="text-xsmall"> Up to $1000</div>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-black.svg" />
            <div class="text-xsmall"> Up to $2000</div>
          </div>
        </div>
      </li>
      <li class="padding-bottom-small">
        <div class="grid margin-top-xsmall">
          <div class="cell cell-large-col-span-3 cell-medium-col-span-8 cell-small-col-span-6">
            <label class="text-small text-black margin-bottom-xsmall"> Rental car excess or bond cover</label>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/not-covered.svg" />
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/not-covered.svg" />
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-black.svg" />
            <div class="text-xsmall"> Up to $2000</div>
          </div>
        </div>
      </li>
      <li class="padding-bottom-small">
        <div class="grid margin-top-xsmall">
          <div class="cell cell-large-col-span-3 cell-medium-col-span-8 cell-small-col-span-6">
            <label class="text-small text-black margin-bottom-xsmall"> Choice of repairer</label>
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/not-covered.svg" />
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/not-covered.svg" />
          </div>
          <div class="cell cell-large-col-span-3 cell-medium-col-span-2 cell-small-col-span-2 cell-tiny-col-span-1">
            <img class="svg icon" src="/assets/svgs/icons/covered-black.svg" />
            <div class="text-xsmall"> We pay the reasonable assessed cost of repairs</div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>


<div class="grid grid-wrapper">
  <div class="cell cell-large-col-span-12">
    <div class="text-small margin-right-small">Huddle car insurance products are subject to terms, limits and exclusions. For full details of these products, read the relevant <a href="https://huddle.com.au/pds" target="_blank">Product Disclosure Statement (PDS)</a> and the <a href="https://huddle.com.au/pds" target="_blank">Target Market Determination (TMD)</a> which explains who the products are suitable for.</div>
  </div>
</div>

